import { render, staticRenderFns } from "./PPCMInputInspection.vue?vue&type=template&id=67d0db54&scoped=true&"
import script from "./PPCMInputInspection.vue?vue&type=script&lang=js&"
export * from "./PPCMInputInspection.vue?vue&type=script&lang=js&"
import style0 from "./PPCMInputInspection.vue?vue&type=style&index=0&id=67d0db54&prod&scoped=true&lang=css&"
import style1 from "./PPCMInputInspection.scss?vue&type=style&index=1&id=67d0db54&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d0db54",
  null
  
)

export default component.exports